import { LookupService } from '../../shared/services/lookup.service';
import { NavigationItemModel } from '../../shared/models/navigation-item-model';
import { MenuItem } from 'primeng/api';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-billing-shell',
  templateUrl: './billing-shell.component.html',
  styleUrls: ['./billing-shell.component.less'],
  standalone: false,
})
export class BillingShellComponent implements OnInit {
  public lastItem: NavigationItemModel;
  public items: NavigationItemModel[];
  private url: string;

  constructor(
    private lookupService: LookupService,
    private translateService: TranslateService,
    private router: Router
  ) {
    this.url = '/billing';
  }

  ngOnInit() {
    this.lookupService.getCachedLookupData();
    this.items = [
      {
        header: this.translateService.instant('label.Transactions'),
        path: 'transactions/list',
        fullPath: this.url.concat('/transactions/list'),
      },
      {
        header: this.translateService.instant('label.Invoices'),
        path: 'invoices/list',
        fullPath: this.url.concat('/invoices/list'),
      },
      {
        header: this.translateService.instant('label.Payments'),
        path: 'payments/list',
        fullPath: this.url.concat('/payments/list'),
      },
      {
        header: this.translateService.instant('label.BillingReport'),
        path: 'report/list',
        fullPath: this.url.concat('/report/list'),
      },
    ];
    this.lastItem = this.items[this.items.length - 1];
  }
}
